export enum DeductionTypes {
	//TABLE PR_Ref_DeductionType

	HealthInsurance = 1,
	TaxDeferredPayment = 2,
	StateRetirement = 3,
	SummerPay = 4,
}
